import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import FunctionBoxAverageV2 from './FunctionBoxAverageV2';
import FunctionBoxCountV2 from './FunctionBoxCountV2';
import FunctionBoxVolumeV2 from './FunctionBoxVolumeV2';
import FunctionBoxNTitleV2 from './FunctionBoxNTitleV2';
import FunctionBoxPublicationsV2 from './FunctionBoxPublicationsV2';
import DynamicTabs from '../common/DynamicTabs';
import GenericButton from '../common/GenericButton';
import Modal from '../common/Modal/Modal';
import AddToDefinition from '../common/AddToDefinition';
import TitleValidationModal from '../crosstab/FunctionBox/TitleValidationModal';
import { PROBABILTIES_FUNCTIONS } from '../../constants';
import { buildFunctionNode } from '../../util/autocodeUtils';
import { getDicForDefKeywords } from '../../actions/autocodeActions';

import * as dictionaryActions from '../../actions/dictionaryActions';

const modalStyle = {
  width: '50%',
  height: '300px',
  left: '40%',
};

const TitleValidationModalStyle = {
  width: '30%',
  height: 'auto',
  left: '45%',
  top: '25%',
};

class FunctionBox extends Component {
  constructor(props) {
    super(props);
    this.getFunctionBoxSampleWeighted();
    this.state = {
      functionTitle: '',
      moveToCustomMessage: '',
    };
  }

  componentWillUnmount() {
    this.props.dictionaryActions.clearSampleWeighted(
      'FunctionBoxCommonDataGrid'
    );
    this.props.dictionaryActions.clearSampleWeighted(
      'FunctionBoxCountDataGrid'
    );
  }

  getFunctionBoxSampleWeighted = () => {
    const selectedKeywords = [];
    const countRangeKeywords = [];
    const selectedNames = [];

    const keywordsString = this.props.selectedTargets.reduce(
      (acc, item) => `${acc}${item.keyword}, `,
      ''
    );

    this.props.selectedTargets.map((item, index, arr) => {
      selectedKeywords.push(item.keyword);
      selectedNames.push(item.shortText);
      countRangeKeywords.push(
        `COUNTRANGE(${keywordsString} ${index}, ${index} )`
      );
      if (index + 1 === arr.length) {
        countRangeKeywords.push(
          `COUNTRANGE(${keywordsString} ${index + 1}, ${index + 1} )`
        );
      }
      return null;
    });
    const sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      weightType: this.props.selectedWeightType.wt,
      divisor: this.props.selectedWeightType.dv,
      isLabelUpdated: [false],
      selectedNames,
    };

    this.props.dictionaryActions.getSampleWeighted({
      ...sampleWeightedParams,
      targetGrid: 'FunctionBoxCommonDataGrid',
      expressionList: selectedKeywords,
    });

    this.props.dictionaryActions.getSampleWeighted({
      ...sampleWeightedParams,
      targetGrid: 'FunctionBoxCountDataGrid',
      expressionList: countRangeKeywords,
    });
  };

  handleTitleText = event =>
    this.setState({ functionTitle: event.target.value });

  moveAppendToCodingBox = (isMove, expressionKeyword, smartSearchArray) =>
    this.props.moveAppendToCodingBox(
      isMove,
      expressionKeyword,
      this.state.functionTitle,
      smartSearchArray
    );

  handleSmartSearchArray = objSmartSearchArray => {
    const newObjectSmartSearchArr = _.cloneDeep(objSmartSearchArray);
    return newObjectSmartSearchArr;
  };

  moveToRows = (expressionKeyword, objSmartSearchArray) => {
    if (this.state.functionTitle) {
      if (expressionKeyword) {
        const sampleWeightedParams = {
          targetGrid: 'RowsDataGrid',
          sourceGrid: 'FunctionBox',
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.moduleStudy.pn,
          weightType: this.props.selectedWeightType.wt,
          divisor: this.props.selectedWeightType.dv,
          expressionList: [expressionKeyword],
          gridData: this.props.moduleRows,
          selectedNames: [this.state.functionTitle],
          isLabelUpdated: [true],
        };
        if (this.props.breadcrumbFlag) {
          sampleWeightedParams.objSmartSearchArray = [
            this.handleSmartSearchArray(objSmartSearchArray),
          ];
        }

        if (sampleWeightedParams.objSmartSearchArray[0].autocodenode) {
          this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        } else {
          getDicForDefKeywords(
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
            this.props.moduleStudy.pn,
            objSmartSearchArray.expressionFormed
          ).then(response => {
            sampleWeightedParams.objSmartSearchArray[0].autocodenode = buildFunctionNode(
              response,
              expressionKeyword,
              objSmartSearchArray.expressionFormed,
              objSmartSearchArray.objectsAdded,
              sampleWeightedParams.isLabelUpdated,
              this.state.functionTitle
            );
            this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
          });
        }
      }
    } else {
      this.setState({
        moveToCustomMessage:
          'You must enter a title to add an expression to rows',
      });
      this.titleValidationModal.show();
    }
  };

  moveToColumns = (expressionKeyword, objSmartSearchArray) => {
    if (this.state.functionTitle) {
      if (expressionKeyword) {
        const sampleWeightedParams = {
          targetGrid: 'ColumnsDataGrid',
          sourceGrid: 'FunctionBox',
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.moduleStudy.pn,
          weightType: this.props.selectedWeightType.wt,
          divisor: this.props.selectedWeightType.dv,
          expressionList: [expressionKeyword],
          gridData: this.props.moduleColumns,
          selectedNames: [this.state.functionTitle],
          isLabelUpdated: [true],
        };

        if (this.props.breadcrumbFlag) {
          sampleWeightedParams.objSmartSearchArray = [
            this.handleSmartSearchArray(objSmartSearchArray),
          ];
        }

        if (sampleWeightedParams.objSmartSearchArray[0].autocodenode) {
          this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        } else {
          getDicForDefKeywords(
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
            this.props.moduleStudy.pn,
            objSmartSearchArray.expressionFormed
          ).then(response => {
            sampleWeightedParams.objSmartSearchArray[0].autocodenode = buildFunctionNode(
              response,
              expressionKeyword,
              objSmartSearchArray.expressionFormed,
              objSmartSearchArray.objectsAdded,
              sampleWeightedParams.isLabelUpdated,
              this.state.functionTitle
            );
            this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
          });
        }
      }
    } else {
      this.setState({
        moveToCustomMessage:
          'You must enter a title to add an expression to columns',
      });
      this.titleValidationModal.show();
    }
  };

  addToDefinition = expressionKeyword => {
    if (this.state.functionTitle) {
      this.setState({
        addToDefinition: [
          {
            id: 0,
            name: this.state.functionTitle,
            expression: expressionKeyword,
          },
        ],
      });
      this.addToDefinitionModal.show();
    } else {
      this.setState({
        moveToCustomMessage:
          'You must enter a title to save this expression to definitions',
      });
      this.titleValidationModal.show();
    }
  };

  // for not letting breadcrumb to be removed
  handleSelect = (index, last) => {
    console.warn(`Selected tab: ${index}, Last tab: ${last}`);
  };

  render() {
    return (
      <div className="function-box">
        <div className="row">
          <div className="small-1 medium-1 large-1 columns">
            <h5 className="middle margin-top-5">Title</h5>
          </div>
          <div className="small-11 medium-11 large-11 columns">
            <input
              type="text"
              id="Name"
              placeholder="Type a Name Here..."
              onChange={this.handleTitleText}
            />
          </div>
          <div className="small-12 columns">
            <DynamicTabs
              tabs={[
                {
                  title: 'Average',
                  content: (
                    <FunctionBoxAverageV2
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                      noExpressionBox={this.props.noExpressionBox}
                      noCRB={this.props.noCRB}
                      sampleWeightedValues={
                        this.props.functionBoxCommonDataGridData
                      }
                    />
                  ),
                },
                {
                  title: 'Count',
                  content: (
                    <FunctionBoxCountV2
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                      noExpressionBox={this.props.noExpressionBox}
                      noCRB={this.props.noCRB}
                      sampleWeightedValues={
                        this.props.functionBoxCountDataGridData
                      }
                    />
                  ),
                },
                {
                  title: 'Volume',
                  content: (
                    <FunctionBoxVolumeV2
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                      noExpressionBox={this.props.noExpressionBox}
                      noCRB={this.props.noCRB}
                      sampleWeightedValues={
                        this.props.functionBoxCommonDataGridData
                      }
                    />
                  ),
                },
                {
                  title: 'N-Tile',
                  content: (
                    <FunctionBoxNTitleV2
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                      noExpressionBox={this.props.noExpressionBox}
                      noCRB={this.props.noCRB}
                      sampleWeightedValues={
                        this.props.functionBoxCommonDataGridData
                      }
                    />
                  ),
                },
                this.props.functionProbabilitiesFlag && {
                  title: 'Publications',
                  content: (
                    <FunctionBoxPublicationsV2
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                      sampleWeightedValues={
                        this.props.functionBoxCommonDataGridData
                      }
                      moduleAction={this.props.moduleAction}
                      probabilityFunctionList={PROBABILTIES_FUNCTIONS}
                      noExpressionBox={this.props.noExpressionBox}
                      noCRB={this.props.noCRB}
                    />
                  ),
                },
              ]}
              moduleStudy={this.props.moduleStudy}
              activeScreen="functionBox"
              handleSelect={this.handleSelect}
            />
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
            <div className="modal-footer">
              <div className="float-right">
                <GenericButton
                  name="Close"
                  onBtnClick={() => this.props.handleParentHide()}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Title Required"
          ref={node => (this.titleValidationModal = node)}
          dialogStyles={TitleValidationModalStyle}
        >
          <div className="row">
            <TitleValidationModal
              customMessage={this.state.moveToCustomMessage}
              handleParentHide={() => this.titleValidationModal.hide()}
            />
          </div>
        </Modal>
        <Modal
          title="Add to Definition..."
          ref={node => (this.addToDefinitionModal = node)}
          dialogStyles={modalStyle}
        >
          <AddToDefinition
            folderName={this.state.functionTitle}
            newExpressions={this.state.addToDefinition}
            handleHide={() => this.addToDefinitionModal.hide()}
            srcScreen="QuestionsScreen"
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
      </div>
    );
  }
}
FunctionBox.propTypes = {
  handleParentHide: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  selectedTargets: PropTypes.arrayOf(PropTypes.object).isRequired,
  moduleColumns: PropTypes.arrayOf(PropTypes.object),
  moduleRows: PropTypes.arrayOf(PropTypes.object),
  functionBoxCommonDataGridData: PropTypes.arrayOf(PropTypes.object),
  functionBoxCountDataGridData: PropTypes.arrayOf(PropTypes.object),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
  }),
  moduleAction: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  selectedWeightType: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  noExpressionBox: PropTypes.bool,
  noCRB: PropTypes.bool,
  functionProbabilitiesFlag: PropTypes.bool,
  dictionaryActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
  }),
  breadcrumbFlag: PropTypes.bool,
};
function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    functionBoxCommonDataGridData:
      state.dictionary.functionBox.FunctionBoxCommonDataGridData,
    functionBoxCountDataGridData:
      state.dictionary.functionBox.FunctionBoxCountDataGridData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FunctionBox);
